import { c as _c } from "react-compiler-runtime";
/* hs-eslint ignored failing-rules */
/* eslint-disable react/no-unused-prop-types */

import { useContext } from 'react';
import I18n from 'I18n';
import TimezoneTypes from '../constants/TimezoneTypes';
// @ts-expect-error untyped JS module
import formatDuration from '../utils/formatRelativeDuration';
import { I18nHMRContext } from '../internal/i18n-internal';
import { jsx as _jsx } from "react/jsx-runtime";
// @ts-expect-error untyped
const getRelativeDuration = (from, to, options) => formatDuration(I18n.moment.duration(Math.abs(to.diff(from))), options);
function FormattedDuration(t0) {
  const $ = _c(9);
  const {
    includeAffix: t1,
    type: t2,
    from,
    to,
    format,
    combined: t3
  } = t0;
  const includeAffix = t1 === undefined ? false : t1;
  const type = t2 === undefined ? TimezoneTypes.PORTAL : t2;
  const combined = t3 === undefined ? false : t3;
  useContext(I18nHMRContext);
  let duration;
  if ($[0] !== combined || $[1] !== format || $[2] !== from || $[3] !== includeAffix || $[4] !== to || $[5] !== type) {
    const nowMoment = I18n.moment[type]();
    if (!to && !from) {
      duration = "";
    } else {
      if (!to) {
        const fromValue = I18n.moment[type](from);
        duration = format ? getRelativeDuration(fromValue, nowMoment, {
          format,
          combined
        }) : fromValue.toNow(!includeAffix);
      } else {
        if (!from) {
          const toValue = I18n.moment[type](to);
          duration = format ? getRelativeDuration(nowMoment, toValue, {
            format,
            combined
          }) : toValue.fromNow(!includeAffix);
        } else {
          const fromValue_0 = I18n.moment[type](from);
          const toValue_0 = I18n.moment[type](to);
          duration = format ? getRelativeDuration(fromValue_0, toValue_0, {
            format,
            combined
          }) : toValue_0.from(fromValue_0, !includeAffix);
        }
      }
    }
    $[0] = combined;
    $[1] = format;
    $[2] = from;
    $[3] = includeAffix;
    $[4] = to;
    $[5] = type;
    $[6] = duration;
  } else {
    duration = $[6];
  }
  let t4;
  if ($[7] !== duration) {
    t4 = /*#__PURE__*/_jsx("span", {
      children: duration
    });
    $[7] = duration;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
FormattedDuration.displayName = 'FormattedDuration';
export default FormattedDuration;